import React from 'react';

import { Sup } from '@qality/common-components/src/atoms/Sup';
import AtlassianAsyncSelect, {
  components,
} from '@qality/common-components/src/atoms/atlaskit/AsyncSelect';

import {
  GroupHeadlineStyled,
  GroupStyled,
  OptionStyled,
  SingleValueStyled,
} from './AsyncSelect.styled';

const Group = (props: any) => {
  return (
    <GroupStyled>
      <GroupHeadlineStyled>
        {props.label}
        {props.data.required && <Sup>*</Sup>}
      </GroupHeadlineStyled>
      {props.children}
    </GroupStyled>
  );
};

const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <OptionStyled
        isDisabled={props.data.isDisabled}
        isSelected={props.isSelected}
      >
        {props.children}
        {props.data.required && <Sup>*</Sup>}
      </OptionStyled>
    </components.Option>
  );
};

const SingleValue = (props: any) => {
  return (
    <components.SingleValue {...props}>
      <SingleValueStyled>
        {props.children}
        {props.data.required && <Sup>*</Sup>}
      </SingleValueStyled>
    </components.SingleValue>
  );
};

/**
 * Testing react-select component
 * https://stackoverflow.com/questions/41991077/testing-react-select-component
 *
 */
export const AsyncSelect = ({ size, ...props }: any) => {
  /**
   * Changing styles
   * https://react-select.com/props#select-props
   */
  const customStyles = {
    control: (base) => ({
      ...base,
      height: 32,
      minHeight: 32,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    valueContainer: (base) => ({
      ...base,
      height: 28,
      minHeight: 28,
    }),
    input: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
  };

  return (
    <AtlassianAsyncSelect
      {...props}
      {...(size === 'small' ? { styles: customStyles } : null)}
      menuPlacement='auto'
      components={{ Group, Option, SingleValue }}
    />
  );
};
